import React, { useState } from 'react';
import { alcoholMenu, foodMenu } from '../data/menuData';
import './MenuTable.css';

const MenuTable: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'alcohol' | 'food'>('alcohol');
  const [searchTerm, setSearchTerm] = useState('');

  const currentMenu = activeTab === 'alcohol' ? alcoholMenu : foodMenu;

  const filteredMenu = currentMenu.map(category => ({
    ...category,
    items: category.items.filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.description && item.description.toLowerCase().includes(searchTerm.toLowerCase()))
    )
  })).filter(category => category.items.length > 0);

  return (
    <div className="menu-table-container">
      <div className="menu-header">
        <h1>BANGTAN LOUNGE</h1>
        <p>Global Eatery & Bar</p>
      </div>

      <div className="menu-tabs">
        <button
          className={`tab-btn ${activeTab === 'alcohol' ? 'active' : ''}`}
          onClick={() => setActiveTab('alcohol')}
        >
          🍺 Alcohol Menu
        </button>
        <button
          className={`tab-btn ${activeTab === 'food' ? 'active' : ''}`}
          onClick={() => setActiveTab('food')}
        >
          🍽️ Food Menu
        </button>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search menu items..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="menu-categories">
        {(searchTerm ? filteredMenu : currentMenu).map((category, idx) => (
          <div key={idx} className="category-section">
            <div className="category-header">
              <span className="category-icon">{category.icon}</span>
              <h2>{category.title}</h2>
            </div>

            <table className="menu-table">
              <tbody>
                {category.items.map((item, itemIdx) => (
                  <tr key={itemIdx} className="menu-row">
                    <td className="item-name">
                      <div className="item-title">{item.name}</div>
                      {item.description && (
                        <div className="item-description">{item.description}</div>
                      )}
                    </td>
                    <td className="item-price">
                      {item.price30ml && (
                        <div className="price-item">
                          <span className="price-label">30ml</span>
                          <span className="price-value">₹{item.price30ml}</span>
                        </div>
                      )}
                      {item.price && (
                        <div className="price-item">
                          <span className="price-value">₹{item.price}</span>
                        </div>
                      )}
                      {item.priceBotlle && (
                        <div className="price-item">
                          <span className="price-label">Bottle</span>
                          <span className="price-value">₹{item.priceBotlle}</span>
                        </div>
                      )}
                      {item.pricePint && (
                        <div className="price-item">
                          <span className="price-label">Pint</span>
                          <span className="price-value">₹{item.pricePint}</span>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>

      <div className="menu-footer">
        <p>📍 Ostwal Point Building, Mira Road East, Thane - 401107</p>
        <p>📞 +91 9619575411 | 📧 bangtanloungebiz@gmail.com</p>
      </div>
    </div>
  );
};

export default MenuTable;
